(function () {
  if (window.__ayamiComfortProfileInit) return;
  window.__ayamiComfortProfileInit = true;

  var LOCAL_SAVE_PREFIX = 'ayami_comfort_profile_';
  var PENDING_SAVE_KEY = 'ayami_comfort_profile_pending';
  var UPDATE_MODE_KEY = 'ayami_comfort_profile_update';
  var RETAKE_QUERY_PARAM = 'retake';

  var OTHER_VALUE = 'other';
  var OTHER_LABEL = 'Something else not listed';
  var OTHER_DETAIL_SUFFIX = '__other';
  var PREFERENCES_QUESTION_ID = 'preferences';

  var PREFERENCE_GROUP_QUESTION_PREFIX = 'pref_group_';

  /**
   * Preference catalog shown at Level 3.
   * Groups appear only when relevant to Level 1–2 answers; options within a group
   * are filtered to those suggested (except wheelchair paths, which unlock full groups).
   */
  var PREFERENCE_CATALOG = [
    {
      id: 'length_adjustments',
      name: 'Length adjustments',
      subgroups: [
        {
          name: 'For bottoms',
          options: [
            { value: 'bottoms_lower_front_rise', label: 'Lower front rise' },
            { value: 'bottoms_higher_back_rise', label: 'Higher back rise' }
          ]
        },
        {
          name: 'For tops',
          options: [
            { value: 'tops_higher_front_rise', label: 'Higher front rise' },
            { value: 'tops_lower_back_rise', label: 'Lower back rise' }
          ]
        }
      ]
    },
    {
      id: 'closures',
      name: 'Closures',
      options: [
        { value: 'pull_on_from_beneath', label: 'Pull-on from beneath' },
        { value: 'pull_on_from_above', label: 'Pull-on from above' },
        { value: 'elastic_waist', label: 'Elastic waist' },
        { value: 'magnetic_closure', label: 'Magnetic closure' },
        { value: 'velcro_closure', label: 'Velcro closure' },
        { value: 'snap_closure', label: 'Snap closure' },
        { value: 'side_opening', label: 'Side opening' },
        { value: 'front_opening', label: 'Front opening' },
        { value: 'no_closures_in_back', label: 'No closures in the back' },
        { value: 'no_closures', label: 'No closures' }
      ]
    },
    {
      id: 'pressure_sensitivity',
      name: 'Pressure sensitivity',
      options: [
        { value: 'no_bulk_back_sides', label: 'No bulks in the back and sides' },
        { value: 'flat_seams', label: 'Flat seams' },
        {
          value: 'soft_grip_bands',
          label: 'Soft / wider / more relaxed bands (waist, socks) — soft grip'
        },
        { value: 'reduced_fabric_bunching', label: 'Reduced fabric bunching (everywhere)' },
        { value: 'non_irritating_fabrics', label: 'Non-irritating fabrics' },
        { value: 'tag_free', label: 'Tag-free' }
      ]
    },
    {
      id: 'toileting_access',
      name: 'Toileting access',
      options: [
        { value: 'toileting_standard', label: 'Standard' },
        { value: 'easy_access_bathroom', label: 'Easy-access bathroom design' },
        { value: 'catheter_compatible', label: 'Catheter compatible' },
        { value: 'stoma_compatible', label: 'Stoma compatible' }
      ]
    },
    {
      id: 'temperature_regulation',
      name: 'Temperature regulation',
      options: [
        { value: 'cooling', label: 'Cooling' },
        { value: 'breathable', label: 'Breathable' },
        { value: 'warm', label: 'Warm' },
        { value: 'moisture_wicking', label: 'Moisture-wicking' }
      ]
    },
    {
      id: 'transfer_friendliness',
      name: 'Transfer friendliness',
      options: [
        { value: 'easy_transfers', label: 'Easy transfers' },
        { value: 'reinforced_seat', label: 'Reinforced seat' },
        { value: 'stretch_for_transfers', label: 'Stretch for transfers' },
        { value: 'reduced_fabric_bunching', label: 'Reduced fabric bunching (everywhere)' }
      ]
    },
    {
      id: 'safety',
      name: 'Safety',
      options: [
        {
          value: 'wont_catch_in_wheels',
          label: "Won't catch in wheels (hems, sleeves, ornaments, etc.)"
        },
        {
          value: 'wont_drag_against_wheels',
          label: "Won't drag against wheels (can damage clothes)"
        }
      ]
    },
    {
      id: 'fit',
      name: 'Fit',
      options: [
        {
          value: 'athletic_upper_body',
          label: 'Athletic upper body (broader shoulders, larger shoulders and arms)'
        },
        { value: 'athletic_lower_body', label: 'Athletic lower body' },
        { value: 'large_bust_chest_fit', label: 'Fit for a larger bust / chest' },
        { value: 'petite_length_adjustments', label: 'Petite length adjustments' },
        { value: 'tall_length_adjustments', label: 'Tall length adjustments' },
        { value: 'short_stature_fit', label: 'Short stature / dwarfism-friendly fit' },
        { value: 'extended_small_sizes', label: 'Sizes smaller than commonly available' },
        { value: 'extended_large_sizes', label: 'Sizes larger than commonly available' },
        { value: 'custom_proportions', label: 'Custom proportions' },
        { value: 'separate_top_bottom_sizing', label: 'Separate top and bottom sizing' },
        { value: 'asymmetry_adjustments', label: 'Asymmetry adjustments' },
        { value: 'limb_difference_fit', label: 'Limb difference or amputation-friendly fit' },
        { value: 'maternity_fit', label: 'Maternity / pregnancy-friendly fit' },
        { value: 'fluctuating_size_fit', label: 'Fit that works as size or shape fluctuates' }
      ]
    },
    {
      id: 'coverage_privacy',
      name: 'Coverage & privacy',
      options: [
        { value: 'privacy_neckline', label: 'Privacy-conscious neckline' },
        { value: 'privacy_bottoms', label: 'Privacy-conscious bottoms' },
        { value: 'full_coverage_sleeves', label: 'Full-coverage sleeves' },
        { value: 'longer_hems', label: 'Longer hems / garment lengths' },
        { value: 'modest_silhouettes', label: 'Modest silhouettes' },
        { value: 'layering_for_coverage', label: 'Layering-friendly for coverage' },
        { value: 'head_covering_compatible', label: 'Head-covering compatible' },
        { value: 'conceal_scars_marks', label: 'Designed to conceal scars or marks' },
        { value: 'no_riding_up', label: 'No riding up (everywhere)' },
        { value: 'coverage_preferences', label: 'Coverage preferences' }
      ]
    },
    {
      id: 'movement',
      name: 'Movement',
      options: [
        { value: 'stretch_fabric', label: 'Stretch fabric' },
        { value: 'soft_fabric', label: 'Soft fabric' },
        { value: 'low_friction_fabrics', label: 'Low friction fabrics (slightly slippery)' }
      ]
    },
    {
      id: 'medical_accommodations',
      name: 'Medical accommodations',
      options: [
        { value: 'brace_friendly_fit', label: 'Brace-friendly fit' },
        { value: 'prosthesis_friendly_fit', label: 'Prosthesis-friendly fit' },
        { value: 'port_or_tube_access', label: 'Feeding tube or port access' },
        { value: 'mobility_aid_friendly', label: 'Mobility-aid friendly' }
      ]
    },
    {
      id: 'vision_identification',
      name: 'Vision & identification',
      options: [
        { value: 'tactile_markers', label: 'Tactile markers to identify garments' },
        {
          value: 'distinct_textures',
          label: 'Distinct textures to tell garments apart'
        },
        {
          value: 'easy_front_back',
          label: 'Easy to tell front from back'
        },
        {
          value: 'high_contrast_details',
          label: 'High-contrast details (where helpful)'
        },
        {
          value: 'accessible_product_info',
          label: 'Accessible product information (labels, descriptions)'
        }
      ]
    },
    {
      id: 'style_wardrobe',
      name: 'Style & wardrobe',
      options: [
        { value: 'fewer_decisions_support', label: 'Fewer outfit decisions' },
        { value: 'easy_to_match', label: 'Easy-to-match clothing' },
        { value: 'reliable_favourites', label: 'Reliable favourites' },
        { value: 'outfit_suggestions', label: 'Outfit suggestions' },
        { value: 'simpler_wardrobe', label: 'A simpler wardrobe' },
        { value: 'style_first_adaptive', label: 'Style-first adaptive clothing' },
        { value: 'workwear_friendly', label: 'Workwear-friendly styles' },
        { value: 'sustainable_choices', label: 'Sustainable / durable choices' }
      ]
    },
    {
      id: 'shopping_care',
      name: 'Shopping & care',
      options: [
        { value: 'fit_recommendations', label: 'Fit recommendations' },
        { value: 'sizing_guidance', label: 'Sizing guidance' },
        { value: 'size_alerts', label: 'Size alerts' },
        { value: 'sample_programme', label: 'Sample programme' },
        { value: 'reorder_favourites', label: 'Easy reordering of favourites' }
      ]
    }
  ];

  var WHEELCHAIR_GROUP_IDS = [
    'length_adjustments',
    'closures',
    'pressure_sensitivity',
    'toileting_access',
    'temperature_regulation',
    'transfer_friendliness',
    'safety',
    'fit',
    'coverage_privacy',
    'movement'
  ];

  var PREFERENCE_ALIASES = {
    soft_fabrics: 'soft_fabric',
    stretch_fabrics: 'stretch_fabric',
    soft_waistbands: 'soft_grip_bands',
    wider_bands: 'soft_grip_bands',
    relaxed_bands: 'soft_grip_bands',
    front_openings: 'front_opening',
    front_opening: 'front_opening',
    side_openings: 'side_opening',
    side_opening: 'side_opening',
    magnetic_closures: 'magnetic_closure',
    velcro_closures: 'velcro_closure',
    velcro: 'velcro_closure',
    snaps: 'snap_closure',
    elastic_waists: 'elastic_waist',
    pull_on_designs: 'pull_on_from_above',
    pull_on_garments: 'pull_on_from_above',
    cooling_fabrics: 'cooling',
    breathable_fabrics: 'breathable',
    warmer_fabrics: 'warm',
    warmth_retention: 'warm',
    moisture_wicking: 'moisture_wicking',
    moisture_wicking_fabrics: 'moisture_wicking',
    higher_back_rise: 'bottoms_higher_back_rise',
    seated_fit: 'bottoms_higher_back_rise',
    seated_friendly_fit: 'bottoms_higher_back_rise',
    wheel_safe_hems: 'wont_catch_in_wheels',
    transfer_friendly_fabrics: 'easy_transfers',
    catheter_access: 'catheter_compatible',
    stoma_friendly_fit: 'stoma_compatible',
    athletic_upper_body_options: 'athletic_upper_body',
    reduced_bunching: 'reduced_fabric_bunching',
    reduced_pressure_points: 'soft_grip_bands',
    reduced_friction: 'low_friction_fabrics',
    reduced_friction_finishes: 'low_friction_fabrics',
    smooth_fabrics: 'low_friction_fabrics',
    non_irritating: 'non_irritating_fabrics',
    natural_fibres: 'non_irritating_fabrics',
    bamboo_jersey: 'soft_fabric',
    style_first_adaptive_clothing: 'style_first_adaptive',
    workwear_friendly_styles: 'workwear_friendly',
    capsule_wardrobe: 'simpler_wardrobe',
    colour_coordination: 'easy_to_match',
    saved_favourites: 'reliable_favourites',
    reorder_options: 'reorder_favourites',
    made_to_order_production: 'sustainable_choices',
    durable_garments: 'sustainable_choices',
    timeless_designs: 'sustainable_choices',
    repairability: 'sustainable_choices',
    mobility_friendly_fit: 'mobility_aid_friendly',
    access_openings: 'port_or_tube_access',
    adaptive_access: 'easy_access_bathroom',
    adaptive_access_features: 'easy_access_bathroom',
    brace_friendly_fit: 'brace_friendly_fit',
    asymmetry_options: 'asymmetry_adjustments',
    adaptive_sizing: 'asymmetry_adjustments',
    longer_tops: 'no_riding_up',
    moisture_management: 'moisture_wicking'
  };

  var PREFERENCE_LABEL_OVERRIDES = {};

  function preferenceGroupQuestionId(groupId) {
    return PREFERENCE_GROUP_QUESTION_PREFIX + groupId;
  }

  function catalogOptionMap() {
    var map = {};
    PREFERENCE_CATALOG.forEach(function (group) {
      var opts = flattenCatalogGroupOptions(group);
      opts.forEach(function (opt) {
        map[opt.value] = { groupId: group.id, groupName: group.name, label: opt.label };
      });
    });
    return map;
  }

  function flattenCatalogGroupOptions(group) {
    if (group.subgroups && group.subgroups.length) {
      var all = [];
      group.subgroups.forEach(function (sub) {
        (sub.options || []).forEach(function (opt) {
          all.push(opt);
        });
      });
      return all;
    }
    return (group.options || []).slice();
  }

  function preferenceLabel(id) {
    var canonical = canonicalizePreferenceId(id);
    if (PREFERENCE_LABEL_OVERRIDES[canonical]) return PREFERENCE_LABEL_OVERRIDES[canonical];
    var meta = catalogOptionMap()[canonical];
    if (meta) return meta.label;
    return String(canonical || '')
      .split('_')
      .filter(Boolean)
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function preferenceGroup(id) {
    var meta = catalogOptionMap()[canonicalizePreferenceId(id)];
    return meta ? meta.groupName : 'Other';
  }

  function canonicalizePreferenceId(id) {
    var current = id;
    var seen = {};
    while (PREFERENCE_ALIASES[current] && !seen[current]) {
      seen[current] = true;
      current = PREFERENCE_ALIASES[current];
    }
    return current;
  }

  function getOptionByValue(question, value) {
    if (!question || !question.options) return null;
    for (var i = 0; i < question.options.length; i++) {
      if (question.options[i].value === value) return question.options[i];
    }
    return null;
  }

  function isWheelchairPath(answers) {
    return (
      hasAnswerValue(answers, 'context_mobility', 'wheelchair_or_lying') ||
      hasAnswerValue(answers, 'context_mobility', 'wheelchair_use') ||
      hasAnswerValue(answers, 'context_medical_devices', 'wheelchair')
    );
  }

  function getSuggestedPreferenceIds(answers) {
    var suggested = {};
    if (isWheelchairPath(answers)) {
      PREFERENCE_CATALOG.forEach(function (group) {
        if (WHEELCHAIR_GROUP_IDS.indexOf(group.id) === -1) return;
        flattenCatalogGroupOptions(group).forEach(function (opt) {
          // For Fit on wheelchair path, always include athletic upper body;
          // other fit options only if also suggested elsewhere.
          if (group.id === 'fit' && opt.value !== 'athletic_upper_body') return;
          suggested[opt.value] = true;
        });
      });
    }

    QUESTIONS.forEach(function (question) {
      if (question.id === PREFERENCES_QUESTION_ID) return;
      if (question.isPreferenceGroup) return;
      var vals = normalizeAnswerValues(answers[question.id]);
      if (!vals.length) return;
      var exclusive = question.exclusiveValues || [];
      vals.forEach(function (value) {
        if (value === OTHER_VALUE || value === 'not_sure') return;
        var option = getOptionByValue(question, value);
        var prefs =
          (option && option.suggestedPreferences) || question.suggestedPreferences || [];
        // Exclusive options (e.g. prefer not to say) still contribute if they map to prefs.
        if (
          !prefs.length &&
          (exclusive.indexOf(value) !== -1 || value === 'prefer_not')
        ) {
          return;
        }
        prefs.forEach(function (prefId) {
          suggested[canonicalizePreferenceId(prefId)] = true;
        });
      });
    });
    return Object.keys(suggested).sort();
  }

  function getApplicablePreferenceGroups(answers) {
    var suggested = getSuggestedPreferenceIds(answers);
    if (!suggested.length) return [];
    var suggestedSet = {};
    suggested.forEach(function (id) {
      suggestedSet[id] = true;
    });

    var groups = [];
    PREFERENCE_CATALOG.forEach(function (group) {
      var filteredSubgroups = null;
      var filteredOptions = null;

      if (group.subgroups && group.subgroups.length) {
        filteredSubgroups = [];
        group.subgroups.forEach(function (sub) {
          var opts = (sub.options || []).filter(function (opt) {
            return suggestedSet[opt.value];
          });
          if (opts.length) {
            filteredSubgroups.push({ name: sub.name, options: opts });
          }
        });
        if (!filteredSubgroups.length) return;
      } else {
        filteredOptions = (group.options || []).filter(function (opt) {
          return suggestedSet[opt.value];
        });
        if (!filteredOptions.length) return;
      }

      groups.push({
        id: group.id,
        name: group.name,
        subgroups: filteredSubgroups,
        options: filteredOptions
      });
    });
    return groups;
  }

  function buildPreferenceGroupQuestion(group) {
    var options = flattenCatalogGroupOptions(group);
    return {
      id: preferenceGroupQuestionId(group.id),
      level: 3,
      type: 'multi',
      required: false,
      skipOtherOption: true,
      isPreferenceGroup: true,
      preferenceGroupId: group.id,
      title: group.name,
      help: 'Based on your answers, these may help. Select any you would like.',
      options: options,
      subgroups: group.subgroups || null
    };
  }

  function collectSelectedPreferences(answers) {
    var selected = {};
    Object.keys(answers || {}).forEach(function (key) {
      if (key.indexOf(PREFERENCE_GROUP_QUESTION_PREFIX) !== 0) return;
      normalizeAnswerValues(answers[key]).forEach(function (id) {
        selected[canonicalizePreferenceId(id)] = true;
      });
    });
    normalizeAnswerValues(answers && answers[PREFERENCES_QUESTION_ID]).forEach(function (id) {
      selected[canonicalizePreferenceId(id)] = true;
    });
    return Object.keys(selected).sort();
  }

  function groupPreferenceIds(prefIds) {
    var groups = {};
    prefIds.forEach(function (id) {
      var canonical = canonicalizePreferenceId(id);
      var group = preferenceGroup(canonical);
      if (!groups[group]) groups[group] = [];
      if (groups[group].indexOf(canonical) === -1) groups[group].push(canonical);
    });
    var ordered = [];
    PREFERENCE_CATALOG.forEach(function (group) {
      if (!groups[group.name] || !groups[group.name].length) return;
      ordered.push({
        name: group.name,
        preferences: groups[group.name]
      });
    });
    Object.keys(groups).forEach(function (groupName) {
      var known = PREFERENCE_CATALOG.some(function (g) {
        return g.name === groupName;
      });
      if (known) return;
      ordered.push({
        name: groupName,
        preferences: groups[groupName]
      });
    });
    return ordered;
  }

  /**
   * Comfort profile tree: Broad challenge → Specific situation → Preference groups
   * Level 1 = Broad challenge (one multi-select).
   * Level 2 = Specific situation (one follow-up per Level 1 answer); each option maps to preferences.
   * Level 3 = Applicable preference groups, one group per step; customer selects what they want.
   */
  var QUESTIONS = [
    // ── Level 1: Broad challenge ──────────────────────────────────────
    {
      id: 'challenges',
      level: 1,
      title: 'What challenges do you experience with clothing?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      options: [
        { value: 'uncomfortable', label: 'Clothing feels uncomfortable or irritating' },
        { value: 'skin_conditions', label: 'I have a skin condition that affects clothing' },
        { value: 'dressing_effort', label: "Dressing takes more effort than I'd like" },
        { value: 'sizing', label: "Standard sizes don't fit my body well" },
        { value: 'mobility', label: 'I have mobility or movement limitations' },
        { value: 'temperature', label: 'I struggle with temperature regulation' },
        { value: 'medical_devices', label: 'I use medical devices or aids' },
        {
          value: 'visual_impairment',
          label: 'I have a visual impairment'
        },
        {
          value: 'coverage_modesty',
          label: 'I need modest clothing or to hide a particular area'
        },
        {
          value: 'mental_effort',
          label: "Choosing what to wear takes more mental effort than I'd like"
        }
      ]
    },

    // ── Level 2: Specific situation (maps directly to preferences) ────
    {
      id: 'context_uncomfortable',
      level: 2,
      title: 'What contributes most to your discomfort?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'uncomfortable');
      },
      options: [
        {
          value: 'sensitive_skin',
          label: 'Sensitive skin',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'breathable',
            'soft_grip_bands',
            'non_irritating_fabrics'
          ]
        },
        {
          value: 'fabric_texture',
          label: 'Fabric texture',
          suggestedPreferences: [
            'soft_fabric',
            'low_friction_fabrics',
            'flat_seams',
            'non_irritating_fabrics'
          ]
        },
        {
          value: 'seams_labels',
          label: 'Seams or labels',
          suggestedPreferences: [
            'flat_seams',
            'tag_free',
            'no_bulk_back_sides'
          ]
        },
        {
          value: 'pressure_tightness',
          label: 'Pressure or tightness',
          suggestedPreferences: [
            'soft_grip_bands',
            'reduced_fabric_bunching',
            'no_bulk_back_sides',
            'flat_seams'
          ]
        },
        {
          value: 'temperature_discomfort',
          label: 'Temperature-related discomfort',
          suggestedPreferences: [
            'cooling',
            'breathable',
            'moisture_wicking',
            'warm'
          ]
        }
      ]
    },
    {
      id: 'context_skin_conditions',
      level: 2,
      title: 'Which skin condition affects your clothing most?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'skin_conditions');
      },
      options: [
        {
          value: 'eczema_atopic_dermatitis',
          label: 'Eczema / atopic dermatitis',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'breathable',
            'non_irritating_fabrics',
            'moisture_wicking',
            'soft_grip_bands',
            'low_friction_fabrics'
          ]
        },
        {
          value: 'hidradenitis_suppurativa',
          label: 'Hidradenitis suppurativa (HS)',
          suggestedPreferences: [
            'soft_fabric',
            'flat_seams',
            'tag_free',
            'breathable',
            'moisture_wicking',
            'soft_grip_bands',
            'no_bulk_back_sides',
            'reduced_fabric_bunching',
            'non_irritating_fabrics',
            'low_friction_fabrics'
          ]
        },
        {
          value: 'psoriasis',
          label: 'Psoriasis',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'breathable',
            'non_irritating_fabrics',
            'soft_grip_bands',
            'low_friction_fabrics'
          ]
        },
        {
          value: 'mcas',
          label: 'MCAS (Mast Cell Activation Syndrome)',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'non_irritating_fabrics',
            'low_friction_fabrics',
            'soft_grip_bands',
            'breathable',
            'cooling',
            'no_bulk_back_sides',
            'reduced_fabric_bunching'
          ]
        },
        {
          value: 'contact_dermatitis',
          label: 'Contact dermatitis',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'non_irritating_fabrics',
            'low_friction_fabrics'
          ]
        },
        {
          value: 'urticaria_hives',
          label: 'Urticaria / hives',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'breathable',
            'cooling',
            'non_irritating_fabrics',
            'low_friction_fabrics',
            'soft_grip_bands'
          ]
        },
        {
          value: 'extremely_sensitive_reactive',
          label: 'Extremely sensitive / reactive skin without a specific diagnosis',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'breathable',
            'non_irritating_fabrics',
            'soft_grip_bands',
            'low_friction_fabrics'
          ]
        },
        {
          value: 'ichthyosis',
          label: 'Ichthyosis',
          suggestedPreferences: [
            'soft_fabric',
            'tag_free',
            'flat_seams',
            'breathable',
            'non_irritating_fabrics',
            'soft_grip_bands',
            'low_friction_fabrics'
          ]
        }
      ]
    },
    {
      id: 'context_dressing_effort',
      level: 2,
      title: 'What makes dressing more difficult?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'dressing_effort');
      },
      options: [
        {
          value: 'limited_mobility',
          label: 'Limited mobility',
          suggestedPreferences: [
            'front_opening',
            'side_opening',
            'pull_on_from_above',
            'magnetic_closure',
            'stretch_fabric'
          ]
        },
        {
          value: 'limited_hand_dexterity',
          label: 'Limited hand dexterity',
          suggestedPreferences: [
            'magnetic_closure',
            'velcro_closure',
            'snap_closure',
            'pull_on_from_above'
          ]
        },
        {
          value: 'limited_strength',
          label: 'Limited strength',
          suggestedPreferences: [
            'pull_on_from_above',
            'stretch_fabric',
            'magnetic_closure',
            'soft_fabric'
          ]
        },
        {
          value: 'fatigue_low_energy',
          label: 'Fatigue or low energy',
          suggestedPreferences: [
            'pull_on_from_above',
            'magnetic_closure',
            'simpler_wardrobe',
            'easy_to_match',
            'outfit_suggestions'
          ]
        },
        {
          value: 'time_decision_making',
          label: 'Time and decision-making',
          suggestedPreferences: [
            'simpler_wardrobe',
            'easy_to_match',
            'reliable_favourites',
            'outfit_suggestions',
            'fewer_decisions_support'
          ]
        },
        {
          value: 'need_assistance',
          label: 'I often need assistance',
          suggestedPreferences: [
            'front_opening',
            'side_opening',
            'magnetic_closure',
            'pull_on_from_beneath',
            'easy_access_bathroom'
          ]
        }
      ]
    },
    {
      id: 'context_sizing',
      level: 2,
      title: 'What best describes your fit challenges?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'sizing');
      },
      options: [
        {
          value: 'large_bust_chest',
          label: 'I have a large bust / chest relative to my body',
          suggestedPreferences: ['large_bust_chest_fit', 'custom_proportions', 'separate_top_bottom_sizing']
        },
        {
          value: 'upper_lower_different_sizes',
          label: 'My upper and lower body need different sizes',
          suggestedPreferences: ['separate_top_bottom_sizing', 'custom_proportions']
        },
        {
          value: 'tall',
          label: 'I am tall',
          suggestedPreferences: ['tall_length_adjustments']
        },
        {
          value: 'petite',
          label: 'I am petite',
          suggestedPreferences: ['petite_length_adjustments']
        },
        {
          value: 'short_stature_dwarfism',
          label: 'I have short stature / dwarfism',
          suggestedPreferences: [
            'short_stature_fit',
            'petite_length_adjustments',
            'custom_proportions',
            'extended_small_sizes'
          ]
        },
        {
          value: 'need_smaller_sizes',
          label: 'I need sizes smaller than commonly available',
          suggestedPreferences: ['extended_small_sizes', 'petite_length_adjustments', 'sizing_guidance']
        },
        {
          value: 'need_larger_sizes',
          label: 'I need sizes larger than commonly available',
          suggestedPreferences: ['extended_large_sizes', 'sizing_guidance', 'size_alerts']
        },
        {
          value: 'muscular_athletic_build',
          label: 'I have a muscular / athletic build',
          suggestedPreferences: ['athletic_upper_body', 'athletic_lower_body', 'custom_proportions']
        },
        {
          value: 'limb_difference_amputation',
          label: 'I have a limb difference or amputation',
          suggestedPreferences: [
            'limb_difference_fit',
            'asymmetry_adjustments',
            'prosthesis_friendly_fit',
            'magnetic_closure',
            'front_opening'
          ]
        },
        {
          value: 'significant_body_asymmetry',
          label: 'I have significant body asymmetry',
          suggestedPreferences: ['asymmetry_adjustments', 'custom_proportions', 'separate_top_bottom_sizing']
        },
        {
          value: 'pregnant',
          label: 'I am pregnant',
          suggestedPreferences: [
            'maternity_fit',
            'fluctuating_size_fit',
            'soft_grip_bands',
            'stretch_fabric',
            'elastic_waist'
          ]
        },
        {
          value: 'size_shape_fluctuates',
          label: 'My body size or shape changes or fluctuates',
          suggestedPreferences: [
            'fluctuating_size_fit',
            'stretch_fabric',
            'elastic_waist',
            'soft_grip_bands',
            'separate_top_bottom_sizing'
          ]
        }
      ]
    },
    {
      id: 'context_mobility',
      level: 2,
      title: 'Which mobility or movement challenges affect your clothing most?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'mobility');
      },
      options: [
        {
          value: 'limited_upper_body_arm',
          label: 'I have limited upper-body or arm movement',
          suggestedPreferences: [
            'front_opening',
            'magnetic_closure',
            'stretch_fabric',
            'pull_on_from_above',
            'velcro_closure',
            'snap_closure'
          ]
        },
        {
          value: 'limited_lower_body_leg',
          label: 'I have limited lower-body or leg movement',
          suggestedPreferences: [
            'elastic_waist',
            'pull_on_from_beneath',
            'side_opening',
            'stretch_fabric'
          ]
        },
        {
          value: 'limited_range_of_motion',
          label: 'I have limited range of motion or joint mobility',
          suggestedPreferences: [
            'stretch_fabric',
            'soft_fabric',
            'reduced_fabric_bunching',
            'magnetic_closure',
            'pull_on_from_above'
          ]
        },
        {
          value: 'weakness_reduced_strength',
          label: 'I have weakness or reduced strength',
          suggestedPreferences: [
            'pull_on_from_above',
            'stretch_fabric',
            'magnetic_closure',
            'soft_fabric',
            'velcro_closure'
          ]
        },
        {
          value: 'balance_stability',
          label: 'I have balance or stability difficulties',
          suggestedPreferences: [
            'pull_on_from_above',
            'magnetic_closure',
            'front_opening',
            'stretch_fabric',
            'soft_grip_bands'
          ]
        },
        {
          value: 'coordination_motor_control',
          label: 'I have coordination or motor-control difficulties',
          suggestedPreferences: [
            'magnetic_closure',
            'velcro_closure',
            'snap_closure',
            'pull_on_from_above',
            'elastic_waist',
            'no_closures'
          ]
        },
        {
          value: 'wheelchair_or_lying',
          label: 'I use a wheelchair / spend most of the day seated or lying',
          suggestedPreferences: []
        }
      ]
    },
    {
      id: 'context_temperature',
      level: 2,
      title: 'Which temperature-related challenges do you experience most often?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'temperature');
      },
      options: [
        {
          value: 'overheat_easily',
          label: 'I overheat easily',
          suggestedPreferences: ['cooling', 'breathable', 'moisture_wicking']
        },
        {
          value: 'feel_cold_easily',
          label: 'I feel cold easily',
          suggestedPreferences: ['warm']
        },
        {
          value: 'switch_hot_cold',
          label: 'I switch between feeling too hot and too cold',
          suggestedPreferences: ['cooling', 'breathable', 'warm', 'moisture_wicking']
        },
        {
          value: 'sweat_easily_or_heavily',
          label: 'I sweat easily or heavily',
          suggestedPreferences: ['moisture_wicking', 'breathable', 'cooling']
        },
        {
          value: 'hot_flushes_menopause',
          label: 'Hot flushes / menopause or perimenopause',
          suggestedPreferences: ['cooling', 'breathable', 'moisture_wicking', 'soft_fabric']
        },
        {
          value: 'raynauds_poor_circulation',
          label: "Raynaud's phenomenon / poor circulation",
          suggestedPreferences: ['warm', 'soft_fabric', 'soft_grip_bands', 'breathable']
        },
        {
          value: 'dysautonomia_pots',
          label: 'Dysautonomia / POTS',
          suggestedPreferences: [
            'cooling',
            'breathable',
            'moisture_wicking',
            'warm',
            'soft_fabric',
            'soft_grip_bands'
          ]
        },
        {
          value: 'multiple_sclerosis',
          label: 'Multiple sclerosis (MS)',
          suggestedPreferences: [
            'cooling',
            'breathable',
            'moisture_wicking',
            'soft_fabric',
            'stretch_fabric'
          ]
        },
        {
          value: 'thyroid_condition',
          label: 'Thyroid condition',
          suggestedPreferences: ['cooling', 'breathable', 'warm', 'moisture_wicking']
        },
        {
          value: 'diabetes_neuropathy',
          label: 'Diabetes / neuropathy',
          suggestedPreferences: [
            'soft_fabric',
            'soft_grip_bands',
            'flat_seams',
            'non_irritating_fabrics',
            'breathable',
            'warm'
          ]
        },
        {
          value: 'spinal_cord_injury',
          label: 'Spinal cord injury',
          suggestedPreferences: [
            'cooling',
            'breathable',
            'warm',
            'moisture_wicking',
            'soft_fabric',
            'flat_seams',
            'soft_grip_bands',
            'reduced_fabric_bunching'
          ]
        },
        {
          value: 'different_body_warmth_needs',
          label: 'Different parts of my body need different levels of warmth',
          suggestedPreferences: ['warm', 'cooling', 'breathable', 'soft_fabric']
        }
      ]
    },
    {
      id: 'context_medical_devices',
      level: 2,
      title: 'Which type of device or aid should clothing accommodate?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'medical_devices');
      },
      options: [
        {
          value: 'mobility_aid',
          label: 'Mobility aid',
          suggestedPreferences: [
            'mobility_aid_friendly',
            'stretch_fabric',
            'pull_on_from_above',
            'soft_fabric'
          ]
        },
        {
          value: 'wheelchair',
          label: 'Wheelchair',
          suggestedPreferences: []
        },
        {
          value: 'catheter',
          label: 'Catheter',
          suggestedPreferences: [
            'catheter_compatible',
            'easy_access_bathroom',
            'soft_grip_bands'
          ]
        },
        {
          value: 'stoma',
          label: 'Stoma',
          suggestedPreferences: [
            'stoma_compatible',
            'easy_access_bathroom',
            'soft_grip_bands'
          ]
        },
        {
          value: 'braces_orthotics',
          label: 'Braces or orthotics',
          suggestedPreferences: [
            'brace_friendly_fit',
            'stretch_fabric',
            'front_opening',
            'side_opening'
          ]
        },
        {
          value: 'prosthesis',
          label: 'Prosthesis',
          suggestedPreferences: [
            'prosthesis_friendly_fit',
            'asymmetry_adjustments',
            'stretch_fabric'
          ]
        },
        {
          value: 'feeding_tube_or_port',
          label: 'Feeding tube or medical port',
          suggestedPreferences: [
            'port_or_tube_access',
            'soft_fabric',
            'front_opening'
          ]
        }
      ]
    },
    {
      id: 'context_visual_impairment',
      level: 2,
      title: 'Which best describes your vision?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'visual_impairment');
      },
      options: [
        {
          value: 'blindness',
          label: 'Blindness / no functional vision',
          suggestedPreferences: [
            'tactile_markers',
            'distinct_textures',
            'easy_front_back',
            'accessible_product_info',
            'magnetic_closure',
            'pull_on_from_above',
            'easy_to_match',
            'simpler_wardrobe',
            'reliable_favourites',
            'reorder_favourites',
            'outfit_suggestions',
            'fit_recommendations',
            'sizing_guidance'
          ]
        },
        {
          value: 'low_vision',
          label: 'Low vision / partial sight',
          suggestedPreferences: [
            'tactile_markers',
            'distinct_textures',
            'easy_front_back',
            'high_contrast_details',
            'accessible_product_info',
            'magnetic_closure',
            'easy_to_match',
            'reliable_favourites',
            'reorder_favourites',
            'outfit_suggestions',
            'fit_recommendations',
            'sizing_guidance'
          ]
        },
        {
          value: 'colour_blindness',
          label: 'Colour blindness / colour vision deficiency',
          suggestedPreferences: [
            'easy_to_match',
            'outfit_suggestions',
            'distinct_textures',
            'tactile_markers',
            'simpler_wardrobe',
            'accessible_product_info'
          ]
        },
        {
          value: 'reduced_contrast_sensitivity',
          label: 'Reduced contrast sensitivity',
          suggestedPreferences: [
            'high_contrast_details',
            'easy_front_back',
            'accessible_product_info',
            'easy_to_match',
            'tactile_markers',
            'distinct_textures'
          ]
        },
        {
          value: 'visual_processing_difficulties',
          label: 'Visual processing difficulties',
          suggestedPreferences: [
            'simpler_wardrobe',
            'fewer_decisions_support',
            'easy_to_match',
            'outfit_suggestions',
            'reliable_favourites',
            'tactile_markers',
            'distinct_textures',
            'accessible_product_info'
          ]
        },
        {
          value: 'light_sensitivity_photophobia',
          label: 'Light sensitivity / photophobia',
          suggestedPreferences: [
            'accessible_product_info',
            'simpler_wardrobe',
            'reliable_favourites',
            'easy_to_match'
          ]
        }
      ]
    },
    {
      id: 'context_coverage_modesty',
      level: 2,
      title: 'Which best describes what you need?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'coverage_modesty');
      },
      options: [
        {
          value: 'modest_clothing',
          label: 'Modest clothing',
          suggestedPreferences: [
            'modest_silhouettes',
            'full_coverage_sleeves',
            'privacy_neckline',
            'privacy_bottoms',
            'longer_hems',
            'head_covering_compatible',
            'layering_for_coverage',
            'coverage_preferences',
            'no_riding_up'
          ]
        },
        {
          value: 'hide_particular_area',
          label: 'Hide a particular area',
          suggestedPreferences: [
            'conceal_scars_marks',
            'full_coverage_sleeves',
            'privacy_neckline',
            'privacy_bottoms',
            'longer_hems',
            'layering_for_coverage',
            'no_riding_up'
          ]
        }
      ]
    },
    {
      id: 'context_mental_effort',
      level: 2,
      title: 'What contributes most to the mental effort of getting dressed?',
      help: 'Select all that apply.',
      type: 'multi',
      required: true,
      showIf: function (answers) {
        return hasChallenge(answers, 'mental_effort');
      },
      options: [
        {
          value: 'adhd_executive_functioning',
          label: 'ADHD or executive functioning differences',
          suggestedPreferences: [
            'fewer_decisions_support',
            'simpler_wardrobe',
            'outfit_suggestions',
            'reliable_favourites',
            'reorder_favourites',
            'easy_to_match'
          ]
        },
        {
          value: 'autism_social_dress',
          label: 'Autism or difficulty understanding social dress expectations',
          suggestedPreferences: [
            'outfit_suggestions',
            'simpler_wardrobe',
            'easy_to_match',
            'reliable_favourites',
            'workwear_friendly',
            'fewer_decisions_support'
          ]
        },
        {
          value: 'ocd_clothing_rituals',
          label: 'OCD or compulsive thoughts and rituals related to clothing',
          suggestedPreferences: [
            'simpler_wardrobe',
            'reliable_favourites',
            'fewer_decisions_support',
            'easy_to_match',
            'reorder_favourites'
          ]
        },
        {
          value: 'anxiety_wrong_choice',
          label: 'Anxiety or fear of making the wrong choice',
          suggestedPreferences: [
            'outfit_suggestions',
            'reliable_favourites',
            'fit_recommendations',
            'sizing_guidance',
            'easy_to_match',
            'fewer_decisions_support'
          ]
        },
        {
          value: 'depression_low_energy',
          label: 'Depression or low energy',
          suggestedPreferences: [
            'simpler_wardrobe',
            'reliable_favourites',
            'reorder_favourites',
            'pull_on_from_above',
            'magnetic_closure',
            'fewer_decisions_support',
            'outfit_suggestions'
          ]
        },
        {
          value: 'too_many_choices',
          label: 'Too many choices feel overwhelming',
          suggestedPreferences: [
            'fewer_decisions_support',
            'simpler_wardrobe',
            'outfit_suggestions',
            'easy_to_match',
            'reliable_favourites'
          ]
        },
        {
          value: 'matching_outfits_colours',
          label: 'Matching outfits or colours is difficult',
          suggestedPreferences: [
            'easy_to_match',
            'outfit_suggestions',
            'simpler_wardrobe',
            'distinct_textures',
            'tactile_markers'
          ]
        }
      ]
    },
    // Level 3 preference groups are built dynamically in getVisibleQuestions().
  ];

  function hasChallenge(answers, value) {
    var selected = answers.challenges;
    return Array.isArray(selected) && selected.indexOf(value) !== -1;
  }

  function hasAnswerValue(answers, questionId, value) {
    var selected = answers[questionId];
    return Array.isArray(selected) && selected.indexOf(value) !== -1;
  }

  function getQuestionOptions(question) {
    if (!question || question.type === 'text' || question.type === 'preferences' || !question.options) {
      return [];
    }
    var options = [];
    question.options.forEach(function (opt) {
      if (opt.value === OTHER_VALUE) return;
      options.push({ value: opt.value, label: opt.label });
    });
    if (!question.skipOtherOption) {
      options.push({ value: OTHER_VALUE, label: OTHER_LABEL });
    }
    return options;
  }

  function otherDetailKey(questionId) {
    return questionId + OTHER_DETAIL_SUFFIX;
  }

  function needsOtherDetail(question, values) {
    if (!question || question.type === 'preferences' || question.type === 'text') return false;
    var vals = normalizeAnswerValues(values);
    var triggers = [OTHER_VALUE].concat(question.otherDetailValues || []);
    for (var i = 0; i < triggers.length; i++) {
      if (vals.indexOf(triggers[i]) !== -1) return true;
    }
    return false;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getConfig(root) {
    return {
      loggedIn: root.getAttribute('data-customer-logged-in') === 'true',
      customerId: root.getAttribute('data-customer-id') || '',
      loginUrl: root.getAttribute('data-login-url') || '/account/login',
      registerUrl: root.getAttribute('data-register-url') || '/account/register',
      preferencesUrl: root.getAttribute('data-preferences-url') || '/pages/preferences',
      nextUrl: root.getAttribute('data-next-url') || '',
      bridgeMode: root.getAttribute('data-bridge-mode') || 'inline',
      fabricSamplesUrl:
        root.getAttribute('data-fabric-samples-url') ||
        '/products/fabric-sample?from=comfort&select=all',
      quizUrl: root.getAttribute('data-quiz-url') || '/pages/comfort-profile',
      saveUrl: root.getAttribute('data-save-url') || '/apps/ayami-color-guide/comfort-save'
    };
  }

  function storeOnboardingBridge(from, highlights) {
    try {
      sessionStorage.setItem(
        'ayami_onboarding_bridge',
        JSON.stringify({ from: from, highlights: highlights || [] })
      );
    } catch (e) {}
  }

  function comfortHighlightsFromPayload(payload) {
    var highlights = [];
    if (!payload) return highlights;
    var challengeLabels =
      (payload.answers && payload.answers.challenges && payload.answers.challenges.labels) || [];
    challengeLabels.forEach(function (label) {
      if (label) highlights.push(label);
    });
    if (Array.isArray(payload.preferences)) {
      payload.preferences.slice(0, 5).forEach(function (pref) {
        if (pref) highlights.push(String(pref).replace(/_/g, ' '));
      });
    }
    return highlights;
  }

  function onboardingBridgeUrl(config) {
    var raw = (config && config.nextUrl) || '';
    if (!raw) return '';
    try {
      var parsed = new URL(raw, window.location.origin);
      if (!parsed.searchParams.get('from')) parsed.searchParams.set('from', 'comfort');
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      if (String(raw).indexOf('from=') >= 0) return raw;
      return String(raw) + (String(raw).indexOf('?') >= 0 ? '&' : '?') + 'from=comfort';
    }
  }

  function showInlineComfortBridge(root, payload) {
    var quiz = root.querySelector('[data-comfort-profile-quiz]');
    var bridge = root.querySelector('[data-comfort-onboarding-bridge]');
    if (!bridge) return false;
    if (quiz) quiz.classList.add('hidden');
    bridge.classList.remove('hidden');

    try {
      bridge.focus({ preventScroll: true });
    } catch (e) {}
    try {
      bridge.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {}
    return true;
  }

  function continueToOnboarding(config, payload, root) {
    var highlights = comfortHighlightsFromPayload(payload);
    storeOnboardingBridge('comfort', highlights);
    var url = onboardingBridgeUrl(config);
    // Shared onboarding bridge owns next-step / skip routing.
    if (url) {
      window.location.replace(url);
      return;
    }
    if (config && config.bridgeMode !== 'redirect' && root && showInlineComfortBridge(root, payload)) {
      return;
    }
    window.location.replace(
      (config && config.fabricSamplesUrl) ||
        '/products/fabric-sample?from=comfort&select=all'
    );
  }

  function findQuestion(id, answers) {
    for (var i = 0; i < QUESTIONS.length; i++) {
      if (QUESTIONS[i].id === id) return QUESTIONS[i];
    }
    if (id && id.indexOf(PREFERENCE_GROUP_QUESTION_PREFIX) === 0) {
      var groupId = id.slice(PREFERENCE_GROUP_QUESTION_PREFIX.length);
      var groups = getApplicablePreferenceGroups(answers || {});
      for (var g = 0; g < groups.length; g++) {
        if (groups[g].id === groupId) return buildPreferenceGroupQuestion(groups[g]);
      }
      // Fall back to full catalog group so saved answers still resolve labels.
      for (var c = 0; c < PREFERENCE_CATALOG.length; c++) {
        if (PREFERENCE_CATALOG[c].id === groupId) {
          return buildPreferenceGroupQuestion(PREFERENCE_CATALOG[c]);
        }
      }
    }
    return null;
  }

  function getVisibleQuestions(answers) {
    var visible = QUESTIONS.filter(function (question) {
      if (question.id === PREFERENCES_QUESTION_ID) return false;
      return !question.showIf || question.showIf(answers);
    });
    getApplicablePreferenceGroups(answers).forEach(function (group) {
      visible.push(buildPreferenceGroupQuestion(group));
    });
    return visible;
  }

  function pruneAnswers(answers, visible) {
    var keep = {};
    visible.forEach(function (question) {
      if (answers[question.id] != null) keep[question.id] = answers[question.id];
      var detailKey = otherDetailKey(question.id);
      if (answers[detailKey] != null) keep[detailKey] = answers[detailKey];
    });
    return keep;
  }

  function optionLabelMap(question) {
    var map = {};
    getQuestionOptions(question).forEach(function (option) {
      map[option.value] = option.label;
    });
    return map;
  }

  function normalizeAnswerValues(raw) {
    if (Array.isArray(raw)) return raw.slice();
    if (raw == null || raw === '') return [];
    return [String(raw)];
  }

  function buildProfilePayload(answers) {
    var detailed = {};
    Object.keys(answers).forEach(function (questionId) {
      if (questionId.indexOf(OTHER_DETAIL_SUFFIX) !== -1) return;
      if (questionId === PREFERENCES_QUESTION_ID) return;
      var question = findQuestion(questionId, answers);
      if (!question) return;
      var values = normalizeAnswerValues(answers[questionId]);
      if (question.type === 'text') {
        detailed[questionId] = {
          value: values[0] || '',
          label: values[0] || ''
        };
        return;
      }
      var labels = optionLabelMap(question);
      var entry = {
        values: values,
        labels: values.map(function (value) {
          return labels[value] || preferenceLabel(value);
        })
      };
      if (question.isPreferenceGroup) {
        entry.group = question.title;
        entry.preference_group_id = question.preferenceGroupId;
      }
      var otherText = answers[otherDetailKey(questionId)];
      if (otherText) entry.other_text = String(otherText);
      detailed[questionId] = entry;
    });

    var challenges = normalizeAnswerValues(answers.challenges);
    var preferenceValues = collectSelectedPreferences(answers);
    detailed[PREFERENCES_QUESTION_ID] = {
      values: preferenceValues,
      labels: preferenceValues.map(preferenceLabel),
      groups: groupPreferenceIds(preferenceValues).map(function (group) {
        return {
          name: group.name,
          preferences: group.preferences.map(function (id) {
            return { id: id, label: preferenceLabel(id) };
          })
        };
      })
    };
    return {
      version: 3,
      saved_at: new Date().toISOString(),
      challenges: challenges,
      preferences: preferenceValues,
      suggested_preferences: getSuggestedPreferenceIds(answers),
      answers: detailed,
      needs: {
        sensory: challenges.indexOf('uncomfortable') !== -1,
        skin_conditions: challenges.indexOf('skin_conditions') !== -1,
        dressing_ease:
          challenges.indexOf('dressing_effort') !== -1 ||
          challenges.indexOf('mobility') !== -1,
        fit: challenges.indexOf('sizing') !== -1,
        mobility: challenges.indexOf('mobility') !== -1,
        temperature: challenges.indexOf('temperature') !== -1,
        medical_devices: challenges.indexOf('medical_devices') !== -1,
        visual_impairment: challenges.indexOf('visual_impairment') !== -1,
        coverage_modesty: challenges.indexOf('coverage_modesty') !== -1,
        mental_effort: challenges.indexOf('mental_effort') !== -1,
        other: challenges.indexOf('other') !== -1
      }
    };
  }

  function storeLocalSave(customerId, payload) {
    var serialized = JSON.stringify(payload);
    var keys = [];
    if (customerId) keys.push(LOCAL_SAVE_PREFIX + customerId);
    keys.push(LOCAL_SAVE_PREFIX + 'active');
    keys.forEach(function (key) {
      try {
        sessionStorage.setItem(key, serialized);
      } catch (e) {}
      try {
        localStorage.setItem(key, serialized);
      } catch (e) {}
    });
  }

  function loadLocalSave(customerId) {
    var keys = [];
    if (customerId) keys.push(LOCAL_SAVE_PREFIX + customerId);
    keys.push(LOCAL_SAVE_PREFIX + 'active');
    for (var i = 0; i < keys.length; i++) {
      var raw = null;
      try {
        raw = sessionStorage.getItem(keys[i]) || localStorage.getItem(keys[i]);
      } catch (e) {}
      if (!raw) continue;
      try {
        return JSON.parse(raw);
      } catch (e) {}
    }
    return null;
  }

  function clearPendingSave() {
    try {
      sessionStorage.removeItem(PENDING_SAVE_KEY);
    } catch (e) {}
  }

  function readPendingSavePayload() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(PENDING_SAVE_KEY);
    } catch (e) {}
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function saveProfile(config, payload) {
    payload.saved_at = payload.saved_at || new Date().toISOString();

    if (config.saveUrl) {
      return fetch(config.saveUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ profile: payload })
      }).then(function (response) {
        if (!response.ok) {
          var error = new Error('Save failed');
          error.status = response.status;
          error.url = config.saveUrl;
          throw error;
        }
        clearPendingSave();
        storeLocalSave(config.customerId, payload);
        return { ok: true, mode: 'profile' };
      });
    }

    clearPendingSave();
    storeLocalSave(config.customerId, payload);
    return Promise.resolve({ ok: true, mode: 'local' });
  }

  function redirectToLoginForSave(config) {
    // After login, return to the comfort quiz so we can save + show the inline bridge
    // (does not require a published /pages/onboarding page).
    var returnPath = (config && config.quizUrl) || window.location.pathname || '/pages/comfort-profile';
    try {
      var parsed = new URL(returnPath, window.location.origin);
      parsed.searchParams.set('comfort_profile_auto_save', '1');
      returnPath = parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      var separator = returnPath.indexOf('?') >= 0 ? '&' : '?';
      returnPath = returnPath + separator + 'comfort_profile_auto_save=1';
    }
    window.location.href = config.loginUrl + '?return_url=' + encodeURIComponent(returnPath);
  }

  function buildQuizRetakeUrl(quizUrl) {
    if (!quizUrl) return '';
    var separator = quizUrl.indexOf('?') >= 0 ? '&' : '?';
    return quizUrl + separator + RETAKE_QUERY_PARAM + '=1';
  }

  function showSaveHint(root, message, isError) {
    var hint = root.querySelector('[data-comfort-profile-save-hint]');
    if (!hint) return;
    hint.textContent = message || '';
    hint.classList.toggle('hidden', !message);
    hint.classList.toggle('is-error', !!isError);
  }

  function renderQuestionMarkup(question, currentValues, otherText, answersForPrefs) {
    var values = normalizeAnswerValues(currentValues);
    var selected = {};
    values.forEach(function (value) {
      selected[value] = true;
    });
    var showOtherForm = needsOtherDetail(question, values);

    var html =
      '<fieldset class="comfort-profile__question" data-question-id="' +
      escapeHtml(question.id) +
      '">' +
      '<legend class="comfort-profile__question-title">' +
      escapeHtml(question.title) +
      (question.required
        ? ' <span class="comfort-profile__required" aria-hidden="true">*</span>'
        : '') +
      '</legend>';

    if (question.help) {
      html += '<p class="comfort-profile__help">' + escapeHtml(question.help) + '</p>';
    }

    if (question.type === 'text') {
      html +=
        '<label class="comfort-profile__text-label">' +
        '<span class="visually-hidden">' +
        escapeHtml(question.title) +
        '</span>' +
        '<textarea class="comfort-profile__textarea" name="comfort-' +
        escapeHtml(question.id) +
        '" rows="4" placeholder="' +
        escapeHtml(question.placeholder || '') +
        '">' +
        escapeHtml(values[0] || '') +
        '</textarea>' +
        '</label>';
    } else if (question.isPreferenceGroup && question.subgroups && question.subgroups.length) {
      question.subgroups.forEach(function (subgroup) {
        html +=
          '<div class="comfort-profile__pref-subgroup">' +
          '<h3 class="comfort-profile__pref-subgroup-title">' +
          escapeHtml(subgroup.name) +
          '</h3>' +
          '<div class="comfort-profile__options" role="group">';
        (subgroup.options || []).forEach(function (option) {
          var checked = selected[option.value] ? ' checked' : '';
          html +=
            '<label class="comfort-profile__option">' +
            '<input type="checkbox" name="comfort-' +
            escapeHtml(question.id) +
            '" value="' +
            escapeHtml(option.value) +
            '" data-option-label="' +
            escapeHtml(option.label) +
            '"' +
            checked +
            '>' +
            '<span class="comfort-profile__option-label">' +
            escapeHtml(option.label) +
            '</span>' +
            '</label>';
        });
        html += '</div></div>';
      });
    } else if (question.type === 'preferences') {
      var suggested = getSuggestedPreferenceIds(answersForPrefs || {});
      var groups = groupPreferenceIds(suggested);
      if (!groups.length) {
        html += '<p class="comfort-profile__help">No preferences to review yet.</p>';
      } else {
        groups.forEach(function (group) {
          html +=
            '<div class="comfort-profile__pref-group">' +
            '<h3 class="comfort-profile__pref-group-title">' +
            escapeHtml(group.name) +
            '</h3>' +
            '<div class="comfort-profile__options" role="group">';
          group.preferences.forEach(function (prefId) {
            var checked = selected[prefId] ? ' checked' : '';
            var label = preferenceLabel(prefId);
            html +=
              '<label class="comfort-profile__option">' +
              '<input type="checkbox" name="comfort-preferences" value="' +
              escapeHtml(prefId) +
              '" data-option-label="' +
              escapeHtml(label) +
              '"' +
              checked +
              '>' +
              '<span class="comfort-profile__option-label">' +
              escapeHtml(label) +
              '</span>' +
              '</label>';
          });
          html += '</div></div>';
        });
      }
    } else {
      var inputType = question.type === 'single' ? 'radio' : 'checkbox';
      var role = question.type === 'single' ? 'radiogroup' : 'group';
      html += '<div class="comfort-profile__options" role="' + role + '">';
      getQuestionOptions(question).forEach(function (option) {
        var checked = selected[option.value] ? ' checked' : '';
        html +=
          '<label class="comfort-profile__option">' +
          '<input type="' +
          inputType +
          '" name="comfort-' +
          escapeHtml(question.id) +
          '" value="' +
          escapeHtml(option.value) +
          '" data-option-label="' +
          escapeHtml(option.label) +
          '"' +
          checked +
          '>' +
          '<span class="comfort-profile__option-label">' +
          escapeHtml(option.label) +
          '</span>' +
          '</label>';
      });
      html += '</div>';

      html +=
        '<div class="comfort-profile__other-form' +
        (showOtherForm ? '' : ' hidden') +
        '" data-other-form>' +
        '<label class="comfort-profile__other-label" for="comfort-other-' +
        escapeHtml(question.id) +
        '">Please tell us more</label>' +
        '<textarea class="comfort-profile__textarea" id="comfort-other-' +
        escapeHtml(question.id) +
        '" name="comfort-' +
        escapeHtml(question.id) +
        '-other" rows="3" data-other-detail placeholder="Describe in your own words…">' +
        escapeHtml(otherText || '') +
        '</textarea>' +
        '</div>';
    }

    html +=
      '<p class="comfort-profile__error hidden" role="alert" data-question-error></p>' +
      '</fieldset>';
    return html;
  }

  function readCurrentQuestionAnswer(question, fieldset) {
    if (question.type === 'text') {
      var textarea = fieldset.querySelector('textarea:not([data-other-detail])');
      return textarea ? String(textarea.value || '').trim() : '';
    }

    var checked = fieldset.querySelectorAll(
      'input[type="checkbox"]:checked, input[type="radio"]:checked'
    );
    var values = [];
    Array.prototype.forEach.call(checked, function (input) {
      values.push(input.value);
    });
    return values;
  }

  function readOtherDetail(fieldset) {
    var detail = fieldset.querySelector('[data-other-detail]');
    return detail ? String(detail.value || '').trim() : '';
  }

  function toggleOtherForm(question, fieldset) {
    var form = fieldset.querySelector('[data-other-form]');
    if (!form) return;
    var values = readCurrentQuestionAnswer(question, fieldset);
    var show = needsOtherDetail(question, values);
    form.classList.toggle('hidden', !show);
    if (!show) {
      var detail = fieldset.querySelector('[data-other-detail]');
      if (detail) detail.value = '';
    }
  }

  function validateCurrentAnswer(question, value, otherText) {
    if (question.type === 'preferences') return '';
    if (question.type === 'text') {
      if (question.required && !String(value || '').trim()) {
        return 'Please add a short note, or go back and change your earlier answers.';
      }
      return '';
    }

    var values = normalizeAnswerValues(value);
    if (question.required && !values.length) {
      return question.type === 'single'
        ? 'Please choose an option to continue.'
        : 'Please select at least one option to continue.';
    }
    if (question.maxSelections && values.length > question.maxSelections) {
      return 'Please select up to ' + question.maxSelections + ' options.';
    }
    if (needsOtherDetail(question, values) && !String(otherText || '').trim()) {
      return 'Please tell us more about your situation.';
    }
    return '';
  }

  function enforceExclusiveAndMax(question, fieldset, changedInput) {
    if (question.type !== 'multi') return;

    var exclusive = question.exclusiveValues || [];
    var inputs = fieldset.querySelectorAll('input[type="checkbox"]');

    if (changedInput && changedInput.checked && exclusive.indexOf(changedInput.value) !== -1) {
      Array.prototype.forEach.call(inputs, function (input) {
        if (input !== changedInput) input.checked = false;
      });
      return;
    }

    if (changedInput && changedInput.checked && exclusive.length) {
      Array.prototype.forEach.call(inputs, function (input) {
        if (exclusive.indexOf(input.value) !== -1) input.checked = false;
      });
    }

    if (question.maxSelections && changedInput && changedInput.checked) {
      var checked = fieldset.querySelectorAll('input[type="checkbox"]:checked');
      if (checked.length > question.maxSelections) {
        changedInput.checked = false;
      }
    }
  }

  function initQuiz(root) {
    var form = root.querySelector('[data-comfort-profile-form]');
    var stage = root.querySelector('[data-comfort-profile-questions]');
    var progress = root.querySelector('[data-comfort-profile-progress]');
    var backBtn = root.querySelector('[data-comfort-profile-back]');
    var nextBtn = root.querySelector('[data-comfort-profile-next]');
    var submitBtn = root.querySelector('[data-comfort-profile-submit]');
    var result = root.querySelector('[data-comfort-profile-result]');
    if (!form || !stage) return;

    var config = getConfig(root);

    // Post-login: save pending answers and show the step bridge (no /pages/onboarding needed).
    var params = new URLSearchParams(window.location.search || '');
    if (config.loggedIn && params.get('comfort_profile_auto_save') === '1') {
      var pending = readPendingSavePayload();
      if (pending) {
        clearPendingSave();
        showSaveHint(root, 'Saving…', false);
        saveProfile(config, pending)
          .catch(function () {
            storeLocalSave(config.customerId, pending);
          })
          .then(function () {
            continueToOnboarding(config, pending, root);
          });
        return;
      }
    }

    var answers = {};
    var stepIndex = 0;

    function visiblePath() {
      return getVisibleQuestions(answers);
    }

    function currentQuestion() {
      return visiblePath()[stepIndex] || null;
    }

    function syncAggregatedPreferences() {
      var selected = collectSelectedPreferences(answers);
      if (selected.length) answers[PREFERENCES_QUESTION_ID] = selected;
      else delete answers[PREFERENCES_QUESTION_ID];
    }

    function updateProgressLabel(question, path) {
      if (!progress || !question) return;
      if (question.isPreferenceGroup) {
        var prefSteps = path.filter(function (q) {
          return q.isPreferenceGroup;
        });
        var prefIndex = 0;
        for (var p = 0; p < prefSteps.length; p++) {
          if (prefSteps[p].id === question.id) {
            prefIndex = p;
            break;
          }
        }
        progress.textContent =
          'Preferences ' + (prefIndex + 1) + ' of ' + prefSteps.length + ' · ' + question.title;
        return;
      }
      var challengeSteps = path.filter(function (q) {
        return !q.isPreferenceGroup;
      });
      var challengeIndex = 0;
      for (var c = 0; c < challengeSteps.length; c++) {
        if (challengeSteps[c].id === question.id) {
          challengeIndex = c;
          break;
        }
      }
      progress.textContent =
        'Question ' + (challengeIndex + 1) + ' of ' + Math.max(challengeSteps.length, 1);
    }

    function renderStep() {
      syncAggregatedPreferences();
      answers = pruneAnswers(answers, visiblePath());
      var path = visiblePath();
      if (!path.length) return;

      if (stepIndex >= path.length) stepIndex = path.length - 1;
      if (stepIndex < 0) stepIndex = 0;

      var question = path[stepIndex];
      stage.innerHTML = renderQuestionMarkup(
        question,
        answers[question.id],
        answers[otherDetailKey(question.id)],
        answers
      );
      bindQuestionInteractions(question);
      updateNavButtons();
      updateProgressLabel(question, path);
      showSaveHint(root, '', false);
      if (result) {
        result.classList.add('hidden');
        result.innerHTML = '';
      }
    }

    function getProvisionalAnswers() {
      var question = currentQuestion();
      var provisional = {};
      Object.keys(answers).forEach(function (key) {
        provisional[key] = answers[key];
      });
      if (!question) return provisional;

      var fieldset = stage.querySelector('[data-question-id="' + question.id + '"]');
      if (!fieldset) return provisional;

      var value = readCurrentQuestionAnswer(question, fieldset);
      if (question.type === 'text') {
        if (value) provisional[question.id] = value;
        else delete provisional[question.id];
      } else {
        provisional[question.id] = normalizeAnswerValues(value);
        var detail = readOtherDetail(fieldset);
        var detailKey = otherDetailKey(question.id);
        if (needsOtherDetail(question, provisional[question.id]) && detail) {
          provisional[detailKey] = detail;
        } else {
          delete provisional[detailKey];
        }
      }

      return pruneAnswers(provisional, getVisibleQuestions(provisional));
    }

    function updateNavButtons() {
      var question = currentQuestion();
      if (!question) return;

      var provisional = getProvisionalAnswers();
      var path = getVisibleQuestions(provisional);
      var idx = -1;
      for (var i = 0; i < path.length; i++) {
        if (path[i].id === question.id) {
          idx = i;
          break;
        }
      }
      if (idx < 0) idx = stepIndex;

      var isFirst = stepIndex === 0;
      var isLast = idx >= path.length - 1;
      backBtn.classList.toggle('hidden', isFirst);
      nextBtn.classList.toggle('hidden', isLast);
      submitBtn.classList.toggle('hidden', !isLast);
      updateProgressLabel(question, path);
    }

    function bindQuestionInteractions(question) {
      var fieldset = stage.querySelector('[data-question-id="' + question.id + '"]');
      if (!fieldset) return;

      fieldset.addEventListener('change', function (event) {
        var target = event.target;
        if (!target || target.tagName !== 'INPUT') return;
        enforceExclusiveAndMax(question, fieldset, target);
        toggleOtherForm(question, fieldset);
        clearError(fieldset);
        updateNavButtons();
      });

      var textareas = fieldset.querySelectorAll('textarea');
      Array.prototype.forEach.call(textareas, function (textarea) {
        textarea.addEventListener('input', function () {
          clearError(fieldset);
          updateNavButtons();
        });
      });
    }

    function clearError(fieldset) {
      var error = fieldset.querySelector('[data-question-error]');
      if (!error) return;
      error.textContent = '';
      error.classList.add('hidden');
    }

    function showError(fieldset, message) {
      var error = fieldset.querySelector('[data-question-error]');
      if (!error) return;
      error.textContent = message;
      error.classList.remove('hidden');
    }

    function commitCurrentAnswer() {
      var question = currentQuestion();
      if (!question) return false;
      var fieldset = stage.querySelector('[data-question-id="' + question.id + '"]');
      if (!fieldset) return false;

      var value = readCurrentQuestionAnswer(question, fieldset);
      var otherText = readOtherDetail(fieldset);
      var message = validateCurrentAnswer(question, value, otherText);
      if (message) {
        showError(fieldset, message);
        return false;
      }

      var detailKey = otherDetailKey(question.id);
      if (question.type === 'text') {
        if (value) answers[question.id] = value;
        else delete answers[question.id];
        delete answers[detailKey];
      } else {
        answers[question.id] = normalizeAnswerValues(value);
        if (needsOtherDetail(question, answers[question.id]) && otherText) {
          answers[detailKey] = otherText;
        } else {
          delete answers[detailKey];
        }
      }

      answers = pruneAnswers(answers, getVisibleQuestions(answers));
      syncAggregatedPreferences();
      return true;
    }

    function goNext() {
      var question = currentQuestion();
      var questionId = question && question.id;
      if (!commitCurrentAnswer()) return;
      var path = visiblePath();
      var idx = 0;
      for (var i = 0; i < path.length; i++) {
        if (path[i].id === questionId) {
          idx = i;
          break;
        }
      }
      if (idx < path.length - 1) {
        stepIndex = idx + 1;
        renderStep();
      } else {
        updateNavButtons();
      }
    }

    function goBack() {
      if (stepIndex <= 0) return;
      commitCurrentAnswer();
      stepIndex -= 1;
      renderStep();
    }

    function renderSummary(payload) {
      if (!result) return;
      var challengeLabels =
        (payload.answers.challenges && payload.answers.challenges.labels) || [];
      var list = challengeLabels
        .map(function (label) {
          return '<li>' + escapeHtml(label) + '</li>';
        })
        .join('');

      result.innerHTML =
        '<h2 class="comfort-profile__result-title">Your comfort profile</h2>' +
        '<p class="comfort-profile__result-intro">Thanks — we saved what matters for your clothing.</p>' +
        (list
          ? '<ul class="comfort-profile__summary-list">' + list + '</ul>'
          : '') +
        '<p class="comfort-profile__save-hint hidden" data-comfort-profile-save-hint></p>';
      result.classList.remove('hidden');
      try {
        result.focus();
      } catch (e) {}
    }

    function finishAndSave() {
      if (!commitCurrentAnswer()) return;
      var payload = buildProfilePayload(answers);
      renderSummary(payload);

      if (!config.loggedIn) {
        try {
          sessionStorage.setItem(PENDING_SAVE_KEY, JSON.stringify(payload));
        } catch (e) {}
        redirectToLoginForSave(config);
        return;
      }

      showSaveHint(root, 'Saving…', false);
      // Always go to the step 1→2 bridge after a *successful* save (never preferences / account).
      saveProfile(config, payload)
        .then(function () {
          showSaveHint(root, 'Saved. Continuing…', false);
          continueToOnboarding(config, payload, root);
        })
        .catch(function (error) {
          clearPendingSave();
          storeLocalSave(config.customerId, payload);
          var message = 'Could not sync to your profile';
          if (error && error.status) message += ' (HTTP ' + error.status + ')';
          message +=
            '. Tags and cloud save failed — check you are logged in, then try Save again. ' +
            'Local copy kept on this device.';
          showSaveHint(root, message, true);
        });
    }

    backBtn.addEventListener('click', goBack);
    nextBtn.addEventListener('click', goNext);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      finishAndSave();
    });

    renderStep();
  }

  function renderSavedProfile(profile) {
    if (!profile || !profile.answers) {
      return '<p>No comfort profile details found.</p>';
    }

    var blocks = [];
    QUESTIONS.forEach(function (question) {
      if (question.id === PREFERENCES_QUESTION_ID) return;
      var entry = profile.answers[question.id];
      if (!entry) return;

      var body = '';
      if (typeof entry.value === 'string' && entry.value) {
        body = '<p>' + escapeHtml(entry.value) + '</p>';
      } else if (Array.isArray(entry.labels) && entry.labels.length) {
        body =
          '<ul class="comfort-profile__summary-list">' +
          entry.labels
            .map(function (label) {
              return '<li>' + escapeHtml(label) + '</li>';
            })
            .join('') +
          '</ul>';
        if (entry.other_text) {
          body +=
            '<p class="comfort-profile__other-saved"><em>' +
            escapeHtml(entry.other_text) +
            '</em></p>';
        }
      }
      if (!body) return;

      blocks.push(
        '<section class="comfort-profile__saved-block">' +
          '<h3 class="comfort-profile__saved-question">' +
          escapeHtml(question.title) +
          '</h3>' +
          body +
          '</section>'
      );
    });

    var prefEntry = profile.answers[PREFERENCES_QUESTION_ID];
    var prefGroups =
      (prefEntry && prefEntry.groups) ||
      groupPreferenceIds(profile.preferences || []).map(function (group) {
        return {
          name: group.name,
          preferences: group.preferences.map(function (id) {
            return { id: id, label: preferenceLabel(id) };
          })
        };
      });
    if (prefGroups && prefGroups.length) {
      var prefBody = prefGroups
        .map(function (group) {
          var items = (group.preferences || [])
            .map(function (pref) {
              return '<li>' + escapeHtml(pref.label || preferenceLabel(pref.id)) + '</li>';
            })
            .join('');
          if (!items) return '';
          return (
            '<div class="comfort-profile__pref-group">' +
            '<h4 class="comfort-profile__pref-group-title">' +
            escapeHtml(group.name) +
            '</h4>' +
            '<ul class="comfort-profile__summary-list">' +
            items +
            '</ul></div>'
          );
        })
        .join('');
      if (prefBody) {
        blocks.push(
          '<section class="comfort-profile__saved-block">' +
            '<h3 class="comfort-profile__saved-question">Your clothing preferences</h3>' +
            prefBody +
            '</section>'
        );
      }
    }

    if (!blocks.length) return '<p>No comfort profile details found.</p>';
    return blocks.join('');
  }

  function initSavedPage() {
    var root = document.querySelector('[data-comfort-profile-saved]');
    if (!root) return;

    var target = root.querySelector('[data-comfort-profile-saved-content]');
    if (!target) return;

    var config = getConfig(root);
    var params = new URLSearchParams(window.location.search || '');
    var autoSave = params.get('comfort_profile_auto_save') === '1';
    var justSaved = params.get('comfort_saved') === '1';
    var localOnly = params.get('local') === '1';

    if (!config.loggedIn) {
      target.innerHTML =
        '<div class="comfort-profile__empty-state">' +
        '<p>Log in or create an account to view your comfort profile.</p>' +
        '<div class="comfort-profile__actions">' +
        '<a class="button" href="' +
        escapeHtml(config.loginUrl) +
        '">Log in</a>' +
        '<a class="button button--secondary" href="' +
        escapeHtml(config.registerUrl) +
        '">Create account</a>' +
        '</div></div>';
      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }
      return;
    }

    function showProfile(profile, bannerText) {
      var banner = bannerText
        ? '<p class="comfort-profile__saved-banner">' + escapeHtml(bannerText) + '</p>'
        : '';
      var actions =
        '<div class="comfort-profile__actions">' +
        '<a class="button button--secondary" href="' +
        escapeHtml(buildQuizRetakeUrl(config.quizUrl)) +
        '">Update comfort profile</a>' +
        '</div>';
      target.innerHTML = banner + renderSavedProfile(profile) + actions;
      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }
    }

    function showEmpty() {
      target.innerHTML =
        '<div class="comfort-profile__empty-state">' +
        '<p>You have not saved a comfort profile yet.</p>' +
        '<div class="comfort-profile__actions">' +
        '<a class="button" href="' +
        escapeHtml(buildQuizRetakeUrl(config.quizUrl)) +
        '">Start comfort profile</a>' +
        '</div></div>';
      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }
    }

    var pending = autoSave ? readPendingSavePayload() : null;
    if (pending) {
      clearPendingSave();
      showSaveHint(root, 'Saving…', false);
      saveProfile(config, pending)
        .then(function () {
          continueToOnboarding(config, pending, root);
        })
        .catch(function () {
          storeLocalSave(config.customerId, pending);
          continueToOnboarding(config, pending, root);
        });
      return;
    }

    if (justSaved) {
      var scriptElSaved = document.getElementById('ComfortProfileSavedData');
      var savedProfile = null;
      if (scriptElSaved && scriptElSaved.textContent.trim()) {
        try {
          savedProfile = JSON.parse(scriptElSaved.textContent);
        } catch (e) {}
      }
      continueToOnboarding(
        config,
        savedProfile || loadLocalSave(config.customerId),
        root
      );
      return;
    }

    var scriptEl = document.getElementById('ComfortProfileSavedData');
    var fromMetafield = null;
    if (scriptEl && scriptEl.textContent.trim()) {
      try {
        fromMetafield = JSON.parse(scriptEl.textContent);
      } catch (e) {}
    }

    var local = loadLocalSave(config.customerId);
    var profile = fromMetafield || local;
    if (!profile) {
      showEmpty();
      return;
    }

    showProfile(profile, localOnly ? 'Saved on this device. Profile sync may still be pending.' : '');
  }

  function boot() {
    var quizRoot = document.querySelector('[data-comfort-profile-root]');
    if (quizRoot) initQuiz(quizRoot);
    initSavedPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ayamiComfortProfileQuestions = QUESTIONS;
  window.ayamiBuildComfortProfilePayload = buildProfilePayload;
  window.ayamiRenderComfortProfile = renderSavedProfile;
})();
